<template>
  <v-app>
    <router-view name="navigationBar" />
    <v-content class="pt-12">
        <router-view name="content" />
    </v-content>
    <router-view name="footer" />
    <on-loading-overlay
      :overlay-open="loadingOverlay"
    />
  </v-app>
</template>

<script>
import OnLoadingOverlay from './components/OnLoadingOverlay'
import { mapState } from 'vuex'

export default {
  name: 'App',
  components: { OnLoadingOverlay },
  comments: {
    OnLoadingOverlay
  },
  computed: {
    ...mapState({
      loadingOverlay: state => state.app.loadingOverlay
    })
  }
}
</script>

<style>
  .background-linear-gradient-pink-orange {
    background: linear-gradient(90deg, rgba(240, 0, 121, 1) 0%, rgba(240, 143, 68, 1) 100%);
  }

  .slide-fade-enter-active {
    transition: all .35s ease;
  }

  .slide-fade-leave-active {
    transition: all .2s cubic-bezier(1.0, 0.5, 0.8, 1.0);
  }

  .slide-fade-enter, .slide-fade-leave-to {
    transform: translateX(100%);
    opacity: 1;
  }
</style>
